import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AssignedSalespersonDialogComponent } from '../assigned-salesperson-dialog/assigned-salesperson-dialog.component';
import { AssignedSalespersonService } from '../assigned-salesperson.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  standalone: false,
})
export class ContactUsComponent implements OnInit {
  dialogConfig$: Observable<MatDialogConfig<any>>;

  constructor(
    private readonly dialog: MatDialog,
    private assignedSalespersonService: AssignedSalespersonService,
    private snowplowService: ProductAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.dialogConfig$ = this.assignedSalespersonService.dialogConfig$;
  }

  openContactUsDialog(): void {
    this.dialogConfig$.pipe(take(1)).subscribe((dialogConfig) => {
      this.dialog.open(AssignedSalespersonDialogComponent, dialogConfig);
    });
  }
}
